import { ReactNode, useCallback, useState } from "react";
import { createPortal } from "react-dom";

import { SlideSideBar } from "../../atoms";
import {
  CancelMembershipSidebarProviderContext,
  OpenCancelMembershipSidebarOptions,
} from "./CancelMembershipSidebarProviderContext";
import { CancelMembershipForm } from "./components/CollectPastDueInvoiceForm/CancelMembershipForm";

export type CancelMembershipSidebarProviderProps = {
  children: ReactNode;
};

export const CancelMembershipSidebarProvider = ({
  children,
}: CancelMembershipSidebarProviderProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [sidebarState, setSidebarState] =
    useState<OpenCancelMembershipSidebarOptions>();

  const closeSidebar = useCallback(() => {
    setIsVisible(false);
  }, []);

  const openCancelMembershipSidebar = useCallback(
    (options: OpenCancelMembershipSidebarOptions) => {
      setSidebarState(options);
      setIsVisible(true);
    },
    [],
  );

  return (
    <CancelMembershipSidebarProviderContext.Provider
      value={{ openCancelMembershipSidebar }}
    >
      {createPortal(
        <SlideSideBar
          isOpen={isVisible}
          hide={() => closeSidebar()}
          className="!w-full lg:!w-1/3"
        >
          {isVisible && sidebarState && (
            <CancelMembershipForm
              onClose={() => closeSidebar()}
              {...sidebarState}
            />
          )}
        </SlideSideBar>,
        document.body,
      )}
      {children}
    </CancelMembershipSidebarProviderContext.Provider>
  );
};
